module.exports = __webpack_public_path__ + "img/partner8.1c07ec0d.png";